import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { PackagesResultFacade } from '@packages/packages-result/store/packages-result.facade';
import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { PackagesResultFiltersFacade } from '@packages/packages-result/store/package-result-filters.facade';
import {
  SelectedPackageFiltersContainer
} from '@shared/magic-filter-bar/selected-package-filters/selected-package-filters.container';
import { HotelFilterBarService } from '@shared/magic-filter-bar/hotel-filter-bar/services/hotel-filter-bar.service';
import { FilterPipesModule } from '@shared/filters/pipes/filter-pipes.module';
import { FilterBarTagModule } from '@shared/magic-filter-bar/filter-bar-tag/filter-bar-tag.module';
import { SelectedFiltersContModule } from '@shared/magic-filter-bar/selected-filters-cont/selected-filters-cont.module';
import { AirFilterBarService } from '@shared/magic-filter-bar/air-filter-bar/services/air-filter-bar.service';

@NgModule({
  declarations: [
    SelectedPackageFiltersContainer,
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    GlobalPipesModule,
    FilterPipesModule,
    FilterBarTagModule,
    SelectedFiltersContModule,
  ],
  providers: [
    PackagesResultFacade,
    PackagesResultFiltersFacade,
    HotelFilterBarService,
    AirFilterBarService,
  ],
  exports: [
    SelectedPackageFiltersContainer
  ]
})
export class SelectedPackageFiltersModule { }
